import Link from 'gatsby-link';
import React, { Component } from 'react';
import { Container, Image, Menu } from 'semantic-ui-react';

export default class HomeDesktopHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItem: 'home'
        }
    }
    componentDidMount(){

    }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    render() {
        const {activeItem} = this.state;
        return (
            <Container className="mpost-header--home--menu">
                <Menu style={{margin: '0 auto'}} compact secondary inverted>
                    <Menu.Menu position='left'>       
                    <Menu.Item as={Link} className="mpost-header--home--menu-item" to="/" name='HOME' active={activeItem === 'HOME'} onClick={this.handleItemClick} />             
                    <Menu.Item as={Link} className="mpost-header--home--menu-item" to="work/" name='WORK' active={activeItem === 'WORK'} onClick={this.handleItemClick} />
                   </Menu.Menu>
                   <Image centered className="mpost-header--logo--light" src={require('../assets/img/logo-light.svg')} size="medium" />
                    <Menu.Menu position='right'>     
                    <Menu.Item as={Link} className="mpost-header--home--menu-item" to="services/" name='SERVICES' active={activeItem === 'SERVICES'} onClick={this.handleItemClick} />               
                    <Menu.Item as={Link} className="mpost-header--home--menu-item" to="contact/" name='CONTACT' active={activeItem === 'CONTACT'} onClick={this.handleItemClick} />
                   </Menu.Menu>
                </Menu>
            </Container>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/HomeDesktopHeader.js